import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'
import { Category, ResourceType } from '../../../backoffice/library/models/resource'

interface ResourcecategoryAutocompleteProps {
  value: Category[] | null
  resourcetypes: ResourceType[] | null
  brandId?: number
  handleInputChange: (field: string, value: any) => void
}

function ResourcecategoryAutocomplete({ value, resourcetypes, handleInputChange }: ResourcecategoryAutocompleteProps) {
  const { t } = useTranslation(['global'])
  const { resourcecategoriesOptions } = useSelector((state: IRootState) => state.resourcecategory)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const filteredOptions =
    resourcecategoriesOptions.filter((category: Category) =>
      resourcetypes?.some(resourcetype => resourcetype.id === category.resourcetype_id)
    ) || []

  const handleMultiAutoCompleteChange = (categories: Category[]) => {
    handleInputChange('categories', categories)
  }

  return (
    <Autocomplete
      id="autocomplete-resourcecategories"
      ChipProps={{ color: 'secondary' }}
      value={value || []}
      onChange={(_, newValue: any) => {
        handleMultiAutoCompleteChange(newValue)
      }}
      options={filteredOptions}
      multiple
      limitTags={1}
      getOptionLabel={(option: Category) => option?.name || ''}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={params => (
        <TextField
          {...params}
          label={t('category')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={Boolean(errorForm.resourcecategories)}
          helperText={msgForm.resourcecategories}
        />
      )}
    />
  )
}

export default ResourcecategoryAutocomplete
